module.exports = __webpack_public_path__ + "static/media/5S.cde1706e.svg";